<template>
  <div class="cooperation-pay-detail-list-container">
    <div>
      <div class="text-content">
        <span
          >申报日期 ：{{
            item.applyforDate && moment(item.applyforDate).format('YYYY-MM-DD')
          }}</span
        >
      </div>
      <span
        :class="
          item && item.approvestate == '已审核'
            ? 'text-icon-gray'
            : 'text-icon-gold'
        "
        >{{ item && item.approvestate }}</span
      >
    </div>
    <div class="point-text">
      <p>申请金额：{{ item && item.applyamount | money2 }}</p>
      <p>发票金额：{{ item && item.bcinvoiceamount | money2 }}</p>
      <p v-if="item.approvestate == '已审核'">
        实际付款金额：{{ item && item.bcljsfamount | money2 }}
      </p>
    </div>
    <p class="last-text">
      <span>主题：</span><span>{{ item && item.subject }}</span>
    </p>
    <p class="last-text">
      <span>申请编号：</span><span>{{ item && item.applyCode }}</span>
    </p>
    <p class="last-text">
      <span>付款单位：</span><span>{{ item && item.payprovidername }}</span>
    </p>
    <p class="last-text">
      <span>收款单位：</span><span>{{ item && item.receiveprovidername }}</span>
    </p>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'cooperation-pay-detail-list',
  props: {
    isAudit: {
      type: Boolean,
      default: () => true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      moment
    };
  },
  mounted() {},

  components: {},

  methods: {}
};
</script>

<style scoped lang="scss">
.cooperation-pay-detail-list-container {
  color: #666666;
  font-size: 26px;
  padding: 20px;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  z-index: 9;
  .text-content {
    width: 85%;
    display: inline-block;
  }
  .last-text {
    margin-top: 10px;
    display: flex;
    span:nth-child(1) {
      width: 140px;
      line-height: 1.5;
      display: inline-block;
      color: #999;
    }
    span:nth-child(2) {
      flex: 1;
      line-height: 1.5;
      color: #666;
    }
  }
  .point-text {
    font-size: 28px;
    font-weight: 500;
    color: #000000;
    line-height: 1.5;
    p {
      margin-top: 10px;
    }
  }
  .text-icon-gold {
    width: 105px;
    height: 40px;
    display: inline-block;
    background: url('../../../common/images/visa-change/gold-icon.png')
      no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    padding-left: 10px;
    color: white;
    line-height: 40px;
    font-size: 22px;
    position: absolute;
    right: 0px;
  }
  .text-icon-gray {
    width: 105px;
    height: 40px;
    display: inline-block;
    background: url('../../../common/images/visa-change/gray-icon.png')
      no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    padding-left: 10px;
    color: white;
    line-height: 40px;
    font-size: 22px;
    position: absolute;
    right: 0px;
  }
}
</style>
<style lang="scss">
.cooperation-pay-detail-list-container {
}
</style>
